import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button, Divider } from '@mui/material';
import { CheckCircleOutline, MailOutline, Help } from '@mui/icons-material';

const SignupSuccessModal = ({ open, email, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4, p: { xs: 1, md: 2 } } }}>
      <DialogContent sx={{ textAlign: 'center', p: { xs: 2, md: 4 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Box sx={{ bgcolor: '#f0fdf4', borderRadius: '50%', p: 1.5, display: 'inline-flex' }}>
            <CheckCircleOutline sx={{ fontSize: 56, color: '#22c55e' }} />
          </Box>
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#4b5563', mb: 1.5 }}>
          Cadastro realizado com sucesso!
        </Typography>
        <Typography variant="body1" sx={{ color: '#6b7280', mb: 4 }}>
          Sua conta foi criada e estamos muito felizes em ter você conosco.
        </Typography>

        <Box sx={{ bgcolor: '#f0fdf4', borderRadius: 3, p: 3, display: 'flex', alignItems: 'center', gap: 3, mb: 4 }}>
          <Box sx={{ bgcolor: '#dcfce7', borderRadius: '50%', p: 2, display: 'inline-flex', flexShrink: 0 }}>
            <MailOutline sx={{ fontSize: 44, color: '#16a34a' }} />
          </Box>
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" sx={{ fontWeight: 800, color: '#16a34a', mb: 0.5, letterSpacing: '0.02em' }}>
              CONFIRME SEU E-MAIL
            </Typography>
            <Typography variant="body2" sx={{ color: '#374151', mb: 0.5 }}>
              Enviamos um e-mail de confirmação para:
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 700, color: '#16a34a' }}>
              {email}
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2" sx={{ color: '#16a34a', fontWeight: 600, mb: 4, px: 2 }}>
          Para ativar sua conta e acessar a plataforma,<br />
          acesse sua caixa de entrada e clique no link de confirmação.
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, color: '#6b7280', mb: 4 }}>
          <Help sx={{ fontSize: 20, color: '#6b7280' }} />
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            Não encontrou o e-mail? Verifique sua caixa de spam ou lixo eletrônico.
          </Typography>
        </Box>

        <Button
          variant="contained"
          fullWidth
          onClick={onClose}
          sx={{
            bgcolor: '#0a2e3d',
            color: '#fff',
            py: 1.5,
            fontWeight: 'bold',
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1.1rem',
            '&:hover': {
              bgcolor: '#041c26',
            },
          }}
        >
          Ir para o Login
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SignupSuccessModal;
